module.exports = __webpack_public_path__ + "img/slack.fe1fba04.svg";